import { MY_DATA, MY_FAVORITES, MY_LISTINGS, TERMS } from '../../utils/routes';
import { ReactComponent as AdIcon } from '../../assets/rebranding/icons/anuncio.svg';
import { IDSUser } from '../icons';

export const primaryRoutes = [
  {
    path: MY_LISTINGS,
    highlight: true,
    iconName: 'itaufonts_menu_hamburguer',
    hoveringIconName: 'itaufonts_seta',
    name: 'meu icarros'
  },
  {
    path: MY_DATA,
    highlight: false,
    iconName: 'itaufonts_usuario_perfil',
    name: 'perfil'
  },
  {
    path: MY_LISTINGS,
    highlight: false,
    Icon: AdIcon,
    name: 'meus anúncios'
  },
  {
    path: MY_FAVORITES,
    highlight: false,
    iconName: 'itaufonts_heart',
    name: 'favoritos'
  },
  {
    highlight: false,
    iconName: 'itaufonts_seguro_auto',
    name: 'seguros',
    link: 'https://autofacilitau.azulseguros.com.br/?&utm_source=icarros&utm_medium=site&utm_campaign=divulgacao_produto'
  },
  {
    path: TERMS,
    highlight: false,
    iconName: 'itaufonts_documento',
    name: 'termos de adesão'
  }
];

export const secondaryRoutes = [
  {
    path: '/logout',
    highlight: false,
    icon: IDSUser,
    iconName: 'sair',
    name: 'sair'
  }
];
